import {  ContentItem } from 'kentico-cloud-delivery';

export class Banns extends ContentItem {
  
}